// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fWZv","title":"Header_title__17GvP","left":"Header_left__2BDIS","clinicName":"Header_clinicName__NZv4p"};